<template>
  <div class="setting-box">
    <div class="header">{{$t('account.setting.title')}}</div>
    <Form ref="form" :model="form" @submit.native.prevent>
      <FormItem prop="integralSwitch">
        <span class="title" style="padding-right:10px;font-size:13px;">积分消费提醒</span>
        <i-switch size="large" v-model="form.integralSwitch" :true-value="1" :false-value="0">
          <span slot="open">开启</span>
          <span slot="close">关闭</span>
        </i-switch>
      </FormItem>
      <FormItem prop="instructionSwitch">
        <span class="title" style="padding-right:10px;font-size:13px;">使用帮助提醒</span>
        <i-switch size="large" v-model="form.instructionSwitch" :true-value="1" :false-value="0">
          <span slot="open">开启</span>
          <span slot="close">关闭</span>
        </i-switch>
      </FormItem>
    </Form>
    <div class="footer">
      <Button type="primary" :loading="isShowLoader" @click="ok">
        <span v-if="!isShowLoader"><span>{{$t('btn.confirmed')}}</span></span>
        <span v-else>{{$t('btn.confirmed')}}</span>
      </Button>
    </div>
    <Loader :loadType="1" v-show="isShowLoader" class="black"></Loader>
  </div>
</template>

<script>
import Loader from '@/components/layout/Loader'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'UserSettingZH',
  components: { Loader },
  data () {
    return {
      isSubmit: false,
      isShowLoader: false,
      form: {
        integralSwitch: 0,
        instructionSwitch: 0
      }
    }
  },
  computed: {
    ...mapState('account', {
      userSettting: state => state.settting
    })
  },
  watch: {
    userSettting (newVal, oldVal) {
      if (newVal) {
        this.form.integralSwitch = newVal.integralSwitch
        this.form.instructionSwitch = newVal.instructionSwitch
      }
    }
  },
  methods: {
    setForm () {
      this.form.integralSwitch = this.userSettting.integralSwitch || 0
      this.form.instructionSwitch = this.userSettting.instructionSwitch || 0
    },
    ok () {
      this.$Loading.start()
      this.isSubmit = true
      this.isShowLoader = true
      this.$api.account.member.setting.set(this.form, {
        success: response => {
          this.$Loading.finish()
          this.isSubmit = false
          this.isShowLoader = false
          if (response.data.code === 200) {
            this.setModalState(false)
          } else {
            this.$Message.error({content: this.$t('account.setting.codeErrMsg'), closable: true})
          }
        },
        error: errorMsg => {
          this.$Loading.error()
          this.isSubmit = false
          this.isShowLoader = false
          this.$Message.error({content: this.$t('account.setting.errMsg'), closable: true})
        }
      })
      this.setSettings({
        data: {
          integralSwitch: this.form.integralSwitch || 0,
          instructionSwitch: this.form.instructionSwitch || 0
        }
      })
    },
    ...mapMutations({
      setModalState: 'account/setSettingModalState',
      setSettings: 'account/setSettingState'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/account/zh-CN/UserSetting.vue